module.exports = __webpack_public_path__ + "img/1541764575.860fe357.jpg";